<header #stickyHeader class="main-sticky-header sticky top-0 z-50 w-full shadow-[1px_1px_2px_0px_rgba(25,29,52,0.10)]">
  <app-header></app-header>
</header>
<!-- max-sm:mx-4 instead of a bare mx-4: admin-common/styles.css ships a plain .mx-4 loaded after ours,
     which would override the sm:/md:/lg: margins below. -->
<div class="max-sm:mx-4 my-5 sm:mx-6 md:mx-10 lg:mx-16">
  @if (translationsReady$ | async) {
    @for (key of [pageKey]; track key) {
      <router-outlet></router-outlet>
    }
  }
</div>
<app-footer></app-footer>